import * as React from 'react';
import './SmallLetter.scss';
import { ISmallLetterProps } from './ISmallLetter';

const SmallLetter = (props: ISmallLetterProps) => {
    return (
        <div className='letter-wrapper'>
            {props.normal}
            <div className='normal-letter'>
                <span className='small-letter'>{props.small}</span>
            </div>
        </div>
    );
};

export default SmallLetter;
